<template>
	<div>欢迎光临！！！</div>
</template>

<script>
	export default {
		name: "Index",
	}
</script>

<style scoped>



</style>